import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { Box, useTheme } from "@mui/material";

import RequestDemo from "../components/popups/requestDemo";
import StyledButton from "../components/styled/styledButton";

import { isMobileDevice } from "../utils/deviceUtils";
import StyledBox from "../components/styled/styledBox";

export default function Demo() {
  const theme = useTheme();
  const [isOpenRequestDemo, setIsOpenRequestDemo] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setIsMobile(isMobileDevice(userAgent));
  }, []);

  return (
    <>
      <Helmet>
        <title>Partner Element - Demo</title>
        <link rel="icon" href="/favicon.ico" sizes="any" />
      </Helmet>

      <Box>
        <StyledBox>
          <Box
            sx={{
              color: theme.palette.text.neutral,
              height: "590px",
              fontFamily: "Coil",
              fontSize: "80px",
              fontWeight: "400",
              lineHeight: "80px",
              letterSpacing: "-2.4px",
              marginBottom: "64px",
              marginTop: "80px",
              paddingRight: "20%",
              "@media (max-width: 1200px)": {
                fontSize: "70px",
                lineHeight: "70px",
                letterSpacing: "-1.8px",
              },
              "@media (max-width: 1024px)": {
                fontSize: "64px",
                lineHeight: "64px",
                height: "500px",
                letterSpacing: "-1.8px",
              },
              "@media (max-width: 800px)": {
                fontSize: "60px",
                lineHeight: "60px",
                height: "500px",
                letterSpacing: "-1.8px",
              },
              "@media (max-width: 600px)": {
                marginTop: "40px",
                fontSize: "40px",
                lineHeight: "50px",
                letterSpacing: "-1.2px",
                paddingRight: "0",
              },
              "@media (max-width: 400px)": {
                marginTop: "20px",
                fontSize: "40px",
                lineHeight: "50px",
                letterSpacing: "-1.2px",
                paddingRight: "1%",
              },
            }}
          >
            {isMobile ? (
              <>
                <Box>See Partner Element in action</Box>
              </>
            ) : (
              <>
                <Box>See Partner Element in action</Box>
              </>
            )}
            <Box
              sx={{
                width: "100%",
                fontSize: isMobile ? "32px " : "40px",
                fontWeight: " 400",
                lineHeight: "50px",
                letterSpacing: "-0.4px",
                marginBottom: "80px",
                fontFamily: "CoFo Sans",
                "@media (min-width: 1024px)": {
                  paddingTop: "10px",
                },
                "@media (max-width: 1024px)": {
                  width: "638px",
                  fontSize: "36px",
                  lineHeight: "40px",
                },
                "@media (max-width: 800px)": {
                  width: "536px",
                  fontSize: isMobile ? "32px " : "36px",
                  lineHeight: "40px",
                },
                "@media (max-width: 600px)": {
                  width: "80%",
                  fontSize: "24px",
                  lineHeight: "30px",
                  marginTop: "16px",
                  marginBottom: "160px",
                  paddingRight: "20%",
                },
                "@media (max-width: 400px)": {
                  width: "80%",
                  fontSize: "24px",
                  lineHeight: "30px",
                  marginTop: "16px",
                  marginBottom: "120px",
                  paddingRight: "20%",
                },
              }}
            >
              {isMobile ? (
                <>
                  <Box>Experience how Partner Element</Box>
                  <Box>can transform your procurement</Box>
                  <Box>and supplier management</Box>
                </>
              ) : (
                <>
                  <Box>Experience how Partner Element can transform</Box>
                  <Box>your procurement and supplier management</Box>
                </>
              )}
            </Box>

            <StyledButton
              onClick={() => setIsOpenRequestDemo(true)}
              sx={{
                padding: "16px 30px",
                borderRadius: "5px",
                fontWeight: "400",
                fontSize: "18px",
                height: "48px",
                marginBottom: "0",
                width: isMobile ? "100%" : "fit-content",
                "@media (max-width: 600px)": {
                  marginTop: "90px",
                },
                "@media (max-width: 400px)": {
                  marginTop: "90px",
                },
              }}
              variant={"contained"}
              color={"buttonPrimary"}
              label={"Request demo"}
            />
          </Box>
        </StyledBox>
      </Box>

      <RequestDemo
        isOpen={isOpenRequestDemo}
        close={() => setIsOpenRequestDemo(false)}
      />
    </>
  );
} 